import React from "react";
import handImage from "@assets/images/logo/header-popup-hand.png";
import { useTranslation } from "@helpers/translate";

export const ProfileHello = ({ nickname, email }) => {
  const { __ } = useTranslation();

  return (
    <div className="profile-tab__avatar-hello">
      <span>
        {__("profile.hey")}{" "}
        <img
          src={handImage}
          alt="hand"
          className="user-profile-dropdown__hand"
        />
      </span>

      <span>
        {nickname || email || __("profile.profile_name")}
      </span>
    </div>
  );
};
